import React from 'react';
import { CardData } from 'data/types/CardData';

interface TableCardButtonProps {
  cardData: CardData;
  onClick: () => void;
  style?: React.CSSProperties;
}

export const TableCardButton: React.FC<TableCardButtonProps> = ({
  cardData,
  onClick,
  style,
}) => {
  return (
    <button
      style={{
        display: 'flex',
        flexDirection: 'row',
        textAlign: 'left',
        alignItems: 'center',
        padding: 8,
        ...style,
      }}
      onClick={onClick}
    >
      <img
        src={`cards/${cardData.imageName}`}
        alt={cardData.name}
        style={{
          width: 80,
          maxHeight: 60,
          boxShadow: '0 5px 20px rgba(0, 0, 0, 0.3)',
          marginRight: 10,
        }}
      />
      <strong style={{ lineHeight: 1.1, margin: '4px 0' }}>
        {cardData.name}
      </strong>
    </button>
  );
}; 